module.exports = __webpack_public_path__ + "704b9871a347c03fab33ff545c91d8ce.pdf";